var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "node-icon",
    transform: "translate(8.4 8.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(-8.4 -8.4)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5100",
    "data-name": "Path 5100",
    d: "M31.423,20.4V16a4.976,4.976,0,1,0-5.1-8.121l-3.92-2.138a4.977,4.977,0,1,0-9.835,0L8.641,7.87a4.975,4.975,0,1,0-5.228,8.086v4.488a4.975,4.975,0,1,0,5.225,8.09l3.93,2.152a4.977,4.977,0,1,0,9.837-.04l3.89-2.164A4.975,4.975,0,1,0,31.423,20.4Zm-4.7,1.026-6.206-3.3,6.107-3.243A4.975,4.975,0,0,0,28.58,16v4.4A4.972,4.972,0,0,0,26.727,21.424Zm-18.476,0a4.966,4.966,0,0,0-1.995-1.066V16.042a4.974,4.974,0,0,0,2.094-1.155l6.107,3.242ZM30,9.1a2.133,2.133,0,1,1-2.133,2.133A2.135,2.135,0,0,1,30,9.1Zm-4.914,1.344a4.966,4.966,0,0,0,.086,1.994l-6.263,3.325V9.745a4.986,4.986,0,0,0,2.268-1.432Zm-7.6-7.6a2.133,2.133,0,1,1-2.133,2.133A2.135,2.135,0,0,1,17.489,2.844ZM13.8,8.31a4.987,4.987,0,0,0,2.27,1.435v6.019L9.8,12.439a4.958,4.958,0,0,0,.083-2.01ZM4.977,9.1a2.133,2.133,0,1,1-2.133,2.133A2.135,2.135,0,0,1,4.977,9.1Zm0,18.2a2.133,2.133,0,1,1,2.133-2.133A2.135,2.135,0,0,1,4.977,27.3Zm4.91-1.324a4.949,4.949,0,0,0-.115-2.139l6.3-3.343v6.161a4.985,4.985,0,0,0-2.286,1.454Zm7.6,7.58a2.133,2.133,0,1,1,2.133-2.133A2.135,2.135,0,0,1,17.489,33.556Zm3.682-5.478a4.986,4.986,0,0,0-2.26-1.424V20.494l6.3,3.343a4.961,4.961,0,0,0-.182,1.33,5.025,5.025,0,0,0,.055.736ZM30,27.3a2.133,2.133,0,1,1,2.133-2.133A2.135,2.135,0,0,1,30,27.3Zm0,0",
    transform: "translate(2.1 1.4)",
    fill: "#fff",
    stroke: "#09c",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeIcon);
export default __webpack_public_path__ + "static/media/node-icon.1db13250912965f435b3b08ee3c0b08f.svg";
export { ForwardRef as ReactComponent };